import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el Mega Pack después de comprar?',
  a: 'Recibirás el acceso al material de forma inmediata para que puedas empezar a usarlo cuanto antes, sin esperas ni trámites. Todo en formato PDF listo para descargar.'
}, {
  q: '¿Para qué nivel educativo está pensado?',
  a: 'Está diseñado principalmente para docentes de educación técnica agropecuaria de nivel secundario, aunque también es muy útil para formación docente, institutos agrarios y educación rural de nivel terciario.'
}, {
  q: '¿Sirve para cualquier país hispanohablante?',
  a: 'Sí. El material está desarrollado con referencias a toda América Latina: Argentina, Colombia, México, Perú, Paraguay, Uruguay, Ecuador, Venezuela, Bolivia, Chile y más. Incluye calendarios agrícolas y ejemplos por región.'
}, {
  q: '¿El material es editable?',
  a: 'El material se entrega en formato PDF de alta calidad, listo para usar directamente o imprimir. Es un material terminado y profesional, no un borrador para adaptar.'
}, {
  q: '¿En qué moneda voy a pagar?',
  a: 'Pagás en tu moneda local. El importe se adapta automáticamente al país desde donde comprás, a través de un procesador de pago seguro e internacional.'
}, {
  q: '¿Qué incluye la oferta de USD 27,90?',
  a: 'Llevás todo el Mega Pack Educación Agropecuaria en el Aula (5 tomos + 4 bonos) más el Mega Pack Vivero y Propagación Vegetal 360° completo (3 tomos): fundamentos del vivero, propagación vegetal y proyecto final del vivero escolar.'
}, {
  q: '¿Qué pasa si no me gusta?',
  a: 'Tenés 7 días de garantía total. Si el material no cumple lo que prometemos, te devolvemos el 100% de tu inversión. Sin preguntas. Sin formularios. Sin complicaciones.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 bg-white" data-id="element-79">
      <div className="max-w-3xl mx-auto" data-id="element-80">
        <div className="text-center mb-16" data-id="element-81">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-slate-900" data-id="element-82">
            ❓ Preguntas frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-83">
          {faqs.map((faq, index) => <div key={index} className="bg-cream border border-earth/20 rounded-xl overflow-hidden shadow-sm" data-id="element-84">
              <button className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-85">
                <span className="font-bold text-lg text-slate-900 pr-8" data-id="element-86">
                  {faq.q}
                </span>
                <ChevronDown className={`text-forest transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-87" />
              </button>

              <AnimatePresence data-id="element-88">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-89">
                    <div className="px-6 pb-5 text-slate-700 border-t border-earth/10 pt-4" data-id="element-90">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}